import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsFleetPaperwork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appraisal_data: props.appraisal_data || null,
      data: props.data || null,
      isLoadingAppraisalInfo: (props.appraisal_data !== null) || false,
      jobId: props.jobId || null,
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      appraisal_data: nextProps.appraisal_data,
      jobId: nextProps.jobId
    });
  }

  render() {
    let appraisalFleetWorkImage = [];
    if((!this.state.isLoadingAppraisalInfo && this.state.appraisal_data && this.state.appraisal_data.paperwork)){
      if((this.state.appraisal_data.paperwork.complete)){
        if(this.state.appraisal_data.paperwork.uploadcare_image_urls){
          this.state.appraisal_data.paperwork.uploadcare_image_urls.map((photoName,i) =>
            appraisalFleetWorkImage.push(
              <p className="col-md-4" key={'fleet-paperwork-'+i}>
                  <img src={photoName}className="job-full-details-fleet-paperwork-image img-responsive"/>
              </p>
            )
          )
        }else{
            this.state.appraisal_data.paperwork.photo_names.map((photoName,i) =>
              appraisalFleetWorkImage.push(
                  <p className="col-md-4" key={'fleet-paperwork-'+i}>
                    <img src={"/storage/images/jobs/"+this.state.jobId+"/fleet_paperwork/"+photoName} className="job-full-details-fleet-paperwork-image img-responsive"/>
                  </p>
                )
            )
          }
        }
    }
    
    return (
      <div className="jobs-table-fleet-paperwork-container">
        <h2>Fleet Paperwork</h2>
        {
          (!this.state.isLoadingAppraisalInfo &&
            this.state.appraisal_data &&
            this.state.appraisal_data.paperwork) ?
            <div>
              {(this.state.appraisal_data.paperwork.complete) ?
                <div>
                  <h1>Fleet Paperwork Complete</h1>
                  <div className="row">
                    {appraisalFleetWorkImage}
                  </div>
                </div>
                :
                <div>
                  <strong>Fleet Paperwork NOT Complete</strong>
                </div>
              }
            </div>
            :
            <div>
              {this.state.data.fleet_paperwork_required ?
                <strong>Fleet Paperwork required and not here yet</strong>
                :
                <strong>Fleet paperwork not required</strong>
              }
            </div>
        }
      </div>
    )
  }
}